// extracted by mini-css-extract-plugin
export default {"container":"NuvosWarning_container__OCHYH"};